export default {
  previous: "Previous",
  next: "Next",
  mandatory: "Mandatory",
  selection: "Selection",
  noselection: "Not selected",
  optional: "Optional",
  logo: "Logo",
  logo_front: "Big logo of Front page",
  favicon: "Favicon",
  mynotes: "My Notes",
  enteryoursearchterm: "Enter your search term",
  search: "Search",
  favorites: "Favorites",
  backgrounds: "Backgrounds",
  map: "Map",
  all: "All",
  layers: "Layers",
  layer_detail_edit: "Layer Details / Edit Layer",
  sv_detail_edit: "SV Details / Edit Layer",
  od_detail_edit: "Object Detection Details / Edit Layer",
  noresultsfound: "No results found.",
  pleaseconfirmyoursearchterm: "Please confirm your search term",
  streetview_name: "SV Name",
  streetview_type: "SV Type",
  streetview_list: "SV List",
  streetview: "SV",
  Streetview: "SV",
  photoinquiries: "Photo inquiries",
  inquiries: "Inquiries",
  openapi: "Open API",
  tools: "Tools",
  initialize: "Initialize",
  roadview: "Road View",
  gotocoordinates: "Go to coordinates",
  screen: "Screen",
  data: "Data",
  manage: "Manage",
  user: "User",
  member: "Member",
  MEMBER: "Member",
  admin: "Admin",
  ADMIN: "Admin",
  menu: "Menu",
  mypage: "My Page",
  tomypage: "Go to My Page",
  more: "More",
  domain: "Domain",
  consentForProvidingPersonalInformationToThirdParties:
    "Consent for Providing Personal Information to Third Parties",
  allmaterialsprovidedhavenolegaleffectandareforinformationalpurposesonly:
    "All provided materials have no legal effect and are for informational purposes only.",
  backgroundmap: "Background Map",
  pleaseselectabackgroundmap: "Please select a background map",
  generalmaps: "General Maps",
  settings: "Settings",
  satellitemaps: "Satellite Maps",
  checkyourapiconnectioninformation: "Check your API connection information.",
  vworld: "VWorld",
  tryaddinganewwallpaper: "Try adding a new background map",
  maptools: "Map Tools",
  measurement: "Measurement",
  distance: "Distance",
  area: "Area",
  radius: "Radius",
  slope: "Slope",
  splitscreen: "Split Screen",
  singlepane: "Single Pane",
  mapauthoring: "Map Authoring",
  "2split": "2 Split",
  quartering: "4 Split",
  savingamapasanimage: "Save map as an image",
  themapwillbeinitializeddoyouwanttoproceed:
    "The map will be initialized. Do you want to proceed?",
  cancel: "Cancel",
  confirm: "Confirm",
  coordinatesystem: "Coordinate System",
  epsg4326: "EPSG:4326",
  epsg: "EPSG",
  xcoordinate: "X Coordinate",
  ycoordinate: "Y Coordinate",
  move: "Move",
  hangle: "Initial Angle Horizontal",
  vangle: "Initial Angle Vertical",
  premise: "Premise",
  places: "Places",
  places_addr: "Places/Address",
  addr: "Address",
  viewdetails: "View Details",
  changecolor: "Change Color",
  viewdatadetails: "View Data Details",
  viewsvdetails: "View SV Details",
  datadetails: "Data Details",
  mynoteslist: "My Notes List",
  attr_field_list: "Attribute Field List",
  wrong_geom: "Invalid coordinates",
  number: "Number",
  registrationmodificationdate: "Registration/Modification Date",
  viewinanewwindow: "View in a new window",
  downloadingdata: "Downloading Data",
  groupname: "Group Name",
  groupexist: "The group already exists.",
  defaultgroups: "Default Groups",
  title: "Title",
  viewthislocationinformation: "View this location information",
  setasdefaultlocation: "Set as default location",
  viewroadview: "View Road View",
  compareroadview: "Compare Road View",
  measuringdistance: "Measure Distance",
  measuretheoradius: "Measure Radius",
  details: "Details",
  propertyinformation: "Property Information",
  architecturalinformation: "Architectural Information",
  coordinateinformation: "Coordinate Information",
  entirelayeroff: "Entire Layer OFF",
  checkitout: "Check it out!",
  nationalbranchlicenseplatestatus: "National Branch License Plate Status",
  pleaseselect: "Please select",
  uniquenumber: "Unique Number",
  statutorycode: "Statutory Code",
  legalname: "Legal Name",
  coloncategorycode: "Land Division Code",
  colonicclarification: "Land Division Name",
  editinformation: "Edit Information",
  checkout: "Check Out",
  comparepastphotos: "Compare Past Photos",
  leftandrightbreaks: "Split Left and Right",
  screenshot: "Screenshot",
  previouspointintime: "Previous Point in Time",
  takenotes: "Take Notes",
  notelist: "Note List",
  fullscreen: "Fullscreen",
  signinisrequired: "Sign in is required.",
  navigatetothelogin: "Navigating to the login page.",
  enteringnotes: "Entering Notes",
  selectagroup: "Select a Group",
  enteratitleupto50characters: "Enter a title (up to 50 characters)",
  pleaseconfirmyourinformation: "Please confirm your information",
  contents: "Contents",
  enteryourcontentupto500: "Enter content (up to 500 characters)",
  coordinates: "Coordinates",
  addressinformation: "Address Information",
  newgroupname: "New Group Name",
  enteranameforyourgroupupto50characters:
    "Enter a name for your group (up to 50 characters)",
  viewconnections: "View Connections",
  panleftandright: "Pan Left and Right",
  man_ext_api: "Manage External API",
  managelayers: "Manage Layers",
  objectdetection: "Object Detection",
  integrationstatus: "Integration Status",
  enabled: "Enabled",
  managestyles: "Manage Styles",
  registermanageroadview: "Register/Manage Road View",
  combinedata: "Combine Data",
  manageroadviewnotes: "Manage Road View Notes",
  managegroups: "Manage Groups",
  integrations: "Integrations",
  download: "Download",
  start_download: "Download Started",
  createnew: "Create New",
  delete: "Delete",
  apikeys: "API Keys",
  normal: "Normal",
  url: "URL",
  not_register_epsg: "Unregistered coordinate system",
  connectiontype: "Connection Type",
  layergroups: "Layer Groups",
  layername: "Layer Name",
  metadatadatasetname: "Metadata Dataset Name",
  showlog_metadata: "Show Logs / Meta Data",
  metadata: "Meta Data",
  metanm: "Dataset name",
  metatype: "Data type",
  metaformat: "Data format",
  metacrs: "Coordinate system",
  metamodinterval: "Update interval",
  metaarea: "Construction area / range",
  metaorg: "Providing organization",
  metamethod: "Data construction method",
  datatypes: "Data Types",
  deploymentregionscope: "Deployment Region / Scope",
  providerorganization: "Provider Organization",
  howwebuilddata: "How We Build Data",
  pleaseentertheurl: "Please enter the URL",
  wms: "WMS",
  streetlightsneedrepairin2022: "Street Lights Need Repair in 2022",
  vectorspaces: "Vector, Space",
  national: "National",
  viewlogs: "View Logs",
  viewlogdetail: "View log details",
  enabledisable: "Enable/Disable",
  dataformats: "Data Formats",
  renewalcycles: "Renewal Cycles",
  apiintegration: "API Integration",
  connectwiththeregisteredapiinformation:
    "Connect with the registered API information.",
  shallweproceed: "Shall we proceed?",
  stoptheassociatedapi: "Stop the associated API.",
  ordering: "Order Management",
  order: "Order",
  modify: "Modify",
  top: "Top",
  up: "Up",
  groomname: "Group Name",
  attractions: "Attractions",
  add: "Add",
  below: "Below",
  down: "Down",
  bottom: "Bottom",
  separation: "Separation",
  layertype: "Layer Types",
  layerkind: "Layer Kinds",
  numberofitems: "Number of Items",
  registeringlayers: "Registering Layers",
  registersv: "Registering SV",
  layerlist: "Layer List",
  layervieworder: "Layer View Order",
  deletelayer: "Delete Layer",
  deletesv: "Delete SV",
  savelayer: "Save Layer",
  savesv: "Save SV",
  enteralayername: "Enter a layer name",
  selectingalayerregistrationmethod: "Select a layer registration method",
  dotmarker: "Dot (Marker)",
  Point: "Dot (Marker)",
  chooseaninputmethod: "Choose an input method",
  inputtype: "Input Type",
  uploadfile: "Upload files",
  uploadimgset: "Upload Image Set",
  no_uploaded_files: "No file was uploaded.",
  vector: "Vector",
  line: "Line",
  directinput: "Direct Input",
  directinput_shp: "Direct Input(shp)",
  directinput_gpkg: "Direct Input(gpkg)",
  vectortype: "Vector Type",
  shpzipcompressedfile: "SHP (ZIP Compressed File)",
  encodingtype: "Encoding Type",
  utf8: "UTF-8",
  genericimages: "Generic Images",
  uploadingfiles: "Uploading Files",
  onuploadonuploadproc: "Process Uploading",
  ospatiallyinformedimagerygeotiff: "Spatially Informed Imagery (GeoTIFF)",
  dropyourfilesheretoupload: "Drop your files here to upload",
  notallowgpxonpolygon:
    "GPX files cannot be uploaded when selecting a polygon.",
  aboutreferencecoordinates: "About Reference Coordinates",
  file: "File",
  upload: "Upload",
  enteranameforthelayerupto50characters:
    "Enter a name for the layer (up to 50 characters)",
  enteranameforthesvupto50characters:
    "Enter a name for the StreetView (up to 50 characters)",
  pleaseconfirmyourinputinformation: "Please confirm your input information",
  managingstylesfieldinformation: "Managing Styles / Field Information",
  chooseastyle: "Choose a style",
  inputmethod: "Input Method",
  managingpropertyfields: "Managing Property Fields",
  itemlist: "Item List",
  type: "Type",
  mapeditmode: "Map Edit Mode",
  style: "Style",
  sharingdatadetails: "Sharing / Data Details",
  layersharingdatadetails: "Layer Sharing / Data Details",
  svsharingdatadetails: "SV Sharing / Data Details",
  managelayersharing: "Manage Layer Sharing",
  managesvsharing: "Manage SV Sharing",
  managesharing: "Manage Sharing",
  viewinglogs: "Viewing Logs",
  viewinglayerlogs: "Viewing Layer Logs",
  sldstylefiles: "SLD Style Files",
  pointmarkerimages: "Point (Marker) Images",
  applying: "Applying",
  jobttl_already_taken: "The position name already exists",
  new: "New",
  create_move: "Create/Move",
  legaladdress: "Legal District Address",
  administrativeaddress: "Administrative District Address",
  youcanchangetheorderofselecteditemsbymovingthemupanddown:
    "You can change the order of selected items by moving them up and down.",
  aboutpropertyfields: "Property Field Information",
  propertyfieldnames: "Property Field Names",
  selectatype: "Select Type",
  text: "Text",
  characterlimit: "Character Limit",
  newregistration: "New Registration",
  enteryourinformation: "Enter your information!",
  whenperformed: "Date and Time Performed",
  gotocurrentlocation: "Go to Current Location",
  "location.error.unavailable":
    "Failed to access your current location. Please check your browser settings.",
  doyouwanttogotoyourcurrentlocation:
    "Do you want to go to your current location?",
  pleaseconfirmtheinformation: "Please confirm the information",
  raster: "Raster",
  spatiallyinformedimagerygeotiff: "Spatially Informed Imagery (GeoTIFF)",
  uploadfileinformation: "Upload File Information",
  selectacoordinatesystem: "Select Coordinate System",
  sharinglayersviewingdatainfo: "Sharing Layers / Viewing Data Info",
  sharingsvviewingdatainfo: "Sharing SV / Viewing Data Info",
  viewingdatainformation: "Viewing Data Information",
  generalimages: "General Images",
  notimgfile: "This is not an image file.",
  learnmore: "Learn More",
  general: "General",
  name: "Name",
  hongyereservoir: "Hongye Reservoir",
  path: "Path",
  size: "Size",
  lastmodified: "Last Modified",
  copied: "copy completed.",
  business_reg_num: "Business registration number",
  mail_order_number: "Mail order number",
  provider: "Provider",
  com_addr: "회사 주소",
  gdail: "GDAL",
  informationfromyourprovider: "Information from Your Provider",
  zones: "Zones",
  width: "Width",
  man_com_info: "Company Information Management",
  set_map_pos: "Map Position Setting",
  height: "Height",
  route: "Routing",
  car: "Car",
  walking: "Walking",
  departure: "Departure",
  stopover: "Stopover",
  destination: "Destination",
  fliat3232bitfloatingpoint: "Float32 - 32-bit Floating Point",
  gdaldriverdescription: "GDAL Driver Description",
  gtiff: "GeoTIFF",
  com_nm: "Company Name",
  ceo: "Chief Executive Officer",
  gdaldrivermetadata: "GDAL Driver Metadata",
  geotiff: "GeoTIFF",
  datasetdescription: "Dataset Description",
  compressionbands: "Compression Bands",
  accumulation: "Accumulation",
  offset: "Offset",
  additionalinformation: "Additional Information",
  dimension: "Dimension",
  origin: "Origin",
  pixelsize: "Pixel Size",
  coordinatesystemcrs: "Coordinate System (CRS)",
  epsg5186kgd2002centralbelt2010: "EPSG:5186 - KGD2002 / Central Belt 2010",
  unit: "Unit",
  meters: "Meters",
  projections: "Projections",
  theresaproblemwiththefileyouuploaded:
    "There is a problem with the file you uploaded.",
  determine_epsg_fail: "Failed to determine coordinate system.",
  thefiletypeisnotsupportedortherequireddatauniquenumberismissing:
    "The file type is not supported or the required data [unique number] is missing.",
  pleasedoublecheckthecontentsofyourfilebeforeattemptingtouploadit:
    "Please double-check the contents of your file before attempting to upload it.",
  deletinglayers: "Deleting Layers",
  nolayersareselected: "No layers are selected.",
  nolayersareregistered: "No layers are registered.",
  nopanomsg: "No registered panoramas available.",
  feelfreetoregisterthelayersyouwant:
    "Feel free to register the layers you want.",
  sharinglayers: "Sharing Layers",
  sharingsv: "Sharing Street View",
  youcanaddupto10usersatatime: "You can add up to 10 users at a time.",
  deleteashare: "Delete Share",
  deletetheshareduser: "Delete the shared user.",
  deleteanitem: "Delete an Item",
  deletearegistereditem: "Delete a registered item.",
  afterdeletionrecoveryisnotpossible:
    "After deletion, recovery is not possible.",
  managedata: "Data Management",
  man_tar: "Target Manage",
  aboutstyles: "Style Information",
  lines: "Lines",
  LineString: "Lines",
  NodeLink: "NodeLink",
  Node: "Node",
  Link: "Link",
  linkdist: "Linking distance",
  detectptdist: "Detecting exist point distance",
  svinfo: "SV Info",
  svedit: "SV Mapping",
  enteranameforyourstyle: "Enter a name for your style",
  preview: "Preview",
  facespolygons: "Faces (Polygons)",
  Polygon: "Polygons",
  stylename: "Style Name",
  registeringdotmarkerstyles: "Registering Dot (Marker) Styles",
  enteranameforyourstyleupto50characters:
    "Enter a name for your style (up to 50 characters)",
  styletypes: "Style Types",
  selectapointmarkertype: "Select a Point (Marker) Type",
  select_type: "Select Types",
  ugh: "Ugh",
  shape: "Shape",
  img: "Image",
  pano_add: "Add Panorama",
  pano_del: "Delete Panorama",
  pano_mod: "Modify Panorama",
  pano: "파노라마",
  dotmarkersize: "Dot (Marker) Size",
  bordercolorsize: "Border Color / Size",
  disable: "Disable",
  whethertousetext: "Whether to use text",
  onoff: "ON/OFF",
  textcontent: "Text Content",
  pleaseenteradescriptionupto50characters:
    "Please enter a description (up to 50 characters)",
  fonts: "Fonts",
  sunnygothic: "Sunny Gothic",
  styles: "Styles",
  fontcolorsize: "Font Color / Size",
  registeringlinestyles: "Registering Line Styles",
  linecolorsize: "Line Color / Size",
  fillcolor: "Fill Color",
  transparency: "Transparency",
  sldstyledetails: "SLD Style Details",
  nofilesareregistered: "No files are registered.",
  registeringalayerroadview: "Registering Layer Road View",
  registeringitems: "Registering Items",
  datetaken: "Date Taken",
  selectadate: "Select a Date",
  dotmarkerdetails: "Dot (Marker) Details",
  linelineorder: "Line Order",
  pleaseentertheinformationorderisarequiredvalue:
    "Please enter the information, order is a required value.",
  enterthedotmarkersequenceinformationthesequenceisarequiredvalue:
    "Please enter the dot (marker) sequence information, sequence is a required value.",
  lists: "Lists",
  tolist: "To list",
  lastlogindt: "Last Login Time",
  addingitems: "Adding Items",
  datamanagementroadview_memomanagement:
    "Data Management > Road View_Memo Management",
  roadviewnoteslist: "Road View Memo List",
  today: "Today",
  yesterday: "Yesterday",
  author: "Author",
  "30daysago": "~ 30 Days Ago",
  "7daysago": "~ 7 Days Ago",
  managemembersusers: "Manage Members (Users):",
  manuallyenrollusers: "Manually Enroll Users",
  membershipnumber: "Membership Number",
  man_member: "Manage Member",
  man_admin: "Manage Admin",
  enteryourmemberidx: "Enter your member ID",
  enteraname: "Enter your name",
  cellphones: "Cellphones",
  enteryourcellphonenumber: "Enter your cellphone number.",
  email: "Email",
  enteryouremailaddress: "Enter your email address",
  enter_email_with_register:
    "Please enter the email address you registered with.",
  email_changed: "Your email address has been updated.",
  searchresults: "Search Results",
  accessibility: "Accessibility",
  membershipclassification: "Membership Classification",
  id: "ID",
  countrycode: "Country Code",
  count: "Counte",
  authorities: "Authorities",
  contact: "Contact",
  companyperiodname: "Company / Period Name",
  joindate: "Join Date",
  useraccess: "User Access",
  accessible: "Accessible",
  username: "Username*",
  pleaseenteryourtoverifyyourinformation:
    "Please enter your username to verify your information",
  password: "Password",
  oinaccessible: "O Inaccessible",
  atemporarypasswordwillbeautomaticallysenttotheemailyouprovided:
    "A temporary password will be automatically sent to the email you provided.",
  pleaseenteraname: "Please enter your name",
  pleaseenteryourcompanyperiodnamepleaseconfirmyourinformation:
    "Please enter your company/period name and confirm your information",
  pleaseenteryourpriorityphoneorcellphonenumber:
    "Please enter your priority phone or cellphone number",
  departmentname: "Department Name",
  dept: "Department",
  upper_dept: "Upper Department",
  man_dept: "Manage Department",
  depth: "depth",
  pleaseenteradepartmentname: "Please enter the department name",
  jobtitle: "Job Title",
  jobtitlename: "Job Title Name",
  man_jobtitle: "Manage Job Title",
  pleaseenteryourjobtitle: "Please enter your job title",
  basicinformation: "Basic Information",
  emailaddress: "Email Address",
  companyorganizationname: "Company / Organization Name",
  membershipdate: "Membership Date",
  emailverificationtime: "Email Verification Time",
  emailverificationcode: "Email Verification Code",
  lastlogin: "Last Login",
  marketingconsent: "Marketing Consent",
  marketingconsentsmssns: "SMS,SNS Marketing Consent",
  alerttalktext: "Alert Talk / Text",
  listeningtime: "Listening Time",
  inquiryapplicationhistory: "Inquiry/Application History",
  unprocessed: "Unprocessed",
  processed: "Processed",
  shortcuts: "Shortcuts",
  helpcenter: "Help Center",
  gotocontactus: "Go to Contact Us",
  roadview_shootinginquiry: "Road View Shooting Inquiry",
  applyforanopenapi: "Apply for an Open API",
  aboutdata: "Data Information",
  numberofdata: "Number of Data",
  filesize: "File Size",
  roadview_notes: "Road View Notes",
  withdrawal: "Withdrawal",
  attention: "Attention!",
  knowwhatinformationisdeletedretainedwhenyouunsubscribeoncedeleteditcantberecovered:
    "Know what information is deleted or retained when you unsubscribe. Once deleted, it cannot be recovered.",
  deleteaccountinformation: "Delete Account Information",
  deleteinquiryhistory: "Delete Inquiry History",
  deletingapiinformation: "Deleting API Information",
  deletemynotes: "Delete My Notes",
  deleteasharedlayer: "Delete Shared Layer",
  enteryourcurrentpassword: "Enter your current password",
  enteryourpassword: "please enter your password",
  unadm: "Terminate Admin",
  move_man_adm: "Move to manage admin",
  turnsoffadministratorprivilegesfortheselecteduser:
    "Turn off administrator privileges for the selected user.",
  no_permission: "You don't have permission.",
  no_required_data: "No required data",
  no_save_data: "No data to save",
  con_save_ttl: "Confirm saving",
  subdata_exists: "Subdata exists",
  addanadmin: "Add an Admin",
  adminscanbeaddedafterregularsignup:
    "Admins can be added after regular signup.",
  notificationsettings: "Notification Settings",
  viewfulllogs: "View Full Logs",
  mapsettings: "Map Settings",
  setcoordinatesystem: "Set Coordinate System",
  announcements: "Announcements",
  helpcentercontacthistory: "Help Center Contact History",
  applytousetheopenapi: "Apply to Use the Open API",
  privacyconsent_required: "Privacy Consent(required)",
  privacyconsent_optional: "Privacy Consent(optional)",
  privacyconsentok:
    "I agree to the collection and use of personal information.",
  termsofuse: "Terms of Use",
  maptype: "Map Type",
  defaultmapornot: "Default Map or Not",
  mapdivisions: "Map Divisions",
  mapname: "Map Name",
  inquery_completed: "Inquiry completed",
  inquery_received: "Your inquiry has been received",
  maptypes: "Map Types",
  userlang: "User Language",
  noregisteredbackgroundmaps: "No registered background maps",
  registermaps: "Register Maps",
  pleaseenteranameforyourmapupto50characters:
    "Please enter a name for your map (up to 50 characters)",
  confirmyourentry: "Confirm your entry",
  sendingemail: "Sending Email",
  manualcreation: "Create Manually",
  aboutapikeys: "API Key Information",
  enteryoururlinformation: "Enter your URL information",
  defaultmapsettings: "Default Map Settings",
  basicmaps: "Basic Maps",
  settingthecoordinatesystem: "Setting the Coordinate System",
  setupyourfavoritecoordinatesystem: "Set up your favorite coordinate system.",
  youcanadddeleteanycoordinatesystemyouwantatanytime:
    "You can add or delete any coordinate system you want at any time.",
  fulllist: "Full list",
  frequentlyusedcoordinatesystems: "Frequently used coordinate systems",
  save: "Save",
  noregisteredinquiries: "No registered inquiries",
  helpcenter11inquiries: "Customer service 1:1 inquiries",
  categories: "Categories",
  pleaseenteryoursearchterm: "Please enter your search term.",
  status: "Status",
  dateofenrollment: "Date of enrollment",
  dateofmod: "Last Modified Date",
  detailcontents: "Detailed contents",
  oneonone_inquery: "1:1 Inquery",
  processingqueue: "Processing queue",
  viewinformation: "View information",
  inquirydetail: "Inquiry contents",
  answer: "Answer contents",
  answerer: "Answerer",
  roadview_inquery: "Road view shooting inquiry",
  handler: "Handler",
  memo: "Memo",
  desiredregion: "Desired region",
  intake: "Intake",
  applicant: "Applicant",
  applicationdate: "Application date",
  issuer: "Issuer",
  keyissuance: "Key issuance",
  reissuance: "Reissue",
  publishedon: "Published on",
  addnotice: "Add notice",
  scheduling: "Scheduling",
  ishidden: "Hidden status",
  exposure: "Exposure",
  hidden: "Hidden",
  fixedtop: "Fixed top status",
  fixed: "Fixed",
  unfixed: "Unfixed",
  pleaseenteratitleupto50characters:
    "Please enter a title (up to 50 characters)",
  pleaseconfirmyourentry: "Please confirm your entry",
  enteradescriptionupto500characters:
    "Please enter a description (up to 500 characters)",
  effectivedate: "Effective date",
  version: "Version",
  registerterms: "Register terms",
  termsofservice: "Terms of service",
  modifyterms: "Modify terms",
  offer: "Offer",
  termsandconditions: "Terms and conditions",
  privacypolicy: "Privacy policy",
  locationterms: "Geolocation services terms of use",
  privacyconsentoptional: "Privacy consent (optional)",
  privacyconsent: "Privacy consent",
  entercontent: "Enter content",
  purposeofcollectingandusingpersonalinformation:
    "Purpose of collecting and using personal information",
  "2whatpersonalinformationdoyoucollect":
    "2. Personal information items collected",
  consenttoreceivepromotionaladvertisinginformationoptional:
    "Consent to receive promotional (advertising) information (optional)",
  selectapromotion: "Select a promotion",
  consenttoreceiveemails: "Consent to Receive Emails",
  measuresnecessarytoensurethesecurityofpersonalinformation:
    "Measures necessary to ensure the security of personal information",
  memberinformationaccesshistory: "Member information access history",
  dateofaccess: "Date of access",
  connectionip: "Connection IP",
  adminname: "Admin name",
  accesspage: "Access page",
  personalinformation: "Personal information",
  downloadexcel: "Download Excel",
  whatyoudo: "What you do",
  adminmenu: "Admin menu",
  servermonitoring: "Server monitoring",
  servertotaldiskcapacity: "Server total disk capacity",
  dataasawhole: "Data as a whole",
  year: "Year",
  usageamount: "Usage amount",
  remainingamount: "Remaining amount",
  statusbydata: "Status by data",
  datasize: "Data size",
  alarmsetting: "Alarm setting",
  alarmlist: "Alarm list",
  eventname: "Event name",
  shippingmethod: "Shipping method",
  manageusers: "Manage users",
  loglist: "Log list",
  processingnumber: "Processing number",
  processingtime: "Processing time",
  workers: "Workers",
  tasktypes: "Task types",
  linetypes: "Line types",
  whatyoureworkingon: "What you're working on",
  taskstatustaskdetailsremarks: "Task status task details (remarks)",
  editmemberinformation: "Edit member information",
  saveinfo: "Save Info",
  logout: "Logout",
  applyforanopenapikey: "Apply for an OPEN API key",
  applyforanopenapikeycomplete: "OPEN API key requested",
  openapikeypublished: "OPEN API key published",
  answered: "Answered",
  waitingforananswer: "Waiting for an answer",
  openapikeyissuanceisrequired: "Open API key issuance is required.",
  openapikeyrequest: "Request OPEN API KEY",
  applynow: "Apply now",
  contactus11: "Contact us 1:1",
  contactus: "Contact us",
  recentactions: "Recent actions",
  managemydata: "Manage my data",
  managemynotes: "Manage my notes",
  sharedlayers: "Shared layers",
  proceedtosignout: "Proceed to sign out",
  youretakentotheloginpage: "You are taken to the login page.",
  verifyyouropenapikey: "Verify your open API key",
  aboutopenapikeys: "About open API keys",
  copytheopenapikey: "Copy the open API key",
  openapikeyissuanceapplicationcompleted:
    "Open API key issuance application completed",
  sharers: "Sharers",
  viewonmap: "View on map",
  therearecurrentlynoinquiries: "There are currently no inquiries.",
  "11inquiryhistory": "1:1 inquiry history",
  "11contactregisterlearnmore": "1:1 contact > Register / View details",
  fileattachments: "File attachments",
  changeyourpassword: "Change your password",
  nochangeyourpassword: "Do not change password",
  pw_changed: "Your password has been changed.",
  currentpassword: "Current password",
  pleaseenteryourpassword: "Please enter your password",
  pleaseconfirmyourpassword: "Please confirm your password",
  newpassword: "New password",
  confirmpassword: "Confirm password",
  checksamepasscon: "Please enter the same password.",
  findpasswd: "Password recovery",
  character: "Character",
  optin: "Opt-in",
  activated: "Activated",
  back: "Back",
  changeyouremail: "Change your email",
  entertheemailaddressyoudliketochange:
    "Please enter the email address you want to change",
  pleaseenteryouremailaddress: "Please enter your email address",
  pleasecheckthericecakeinformation: "Please check the rice cake information",
  sendanauthorizationnumber: "Send an authorization number",
  enteryourverificationnumber: "Enter your verification number",
  pleaseenteryourverificationnumber: "Please enter your verification number",
  resend: "Resend",
  didNotReceiveCode: "Didn't receive the code?",
  signin: "Sign in",
  pleaseconfirmtheinformationyouentered:
    "Please confirm the information you entered.",
  forgotyourpassword: "Forgot your password",
  notamemberyet: "Not a member yet?",
  pleasechangeyourpasswordtoprotectyourprivacy:
    "Please change your password to protect your privacy",
  enteranewpassword: "Enter a new password",
  confirmyournewpassword: "Confirm your new password",
  passwordsafetyrules: "Password safety rules",
  lettermin8: "Please enter more than 8 letters",
  at_least_two_of_the_following:
    "You must use at least two of the following: uppercase letters, lowercase letters, numbers, or special characters.",
  useatleast8charactersandatleasttwoofthefollowingupperandlowercaselettersnumbersandspecialcharacters:
    "Use at least 8 characters and at least two of the following: upper and lowercase letters, numbers, and special characters",
  nomorethan4consecutivecharactersdigitsofthesameletternumber1111aaaetc:
    "Do not use more than 4 consecutive characters or digits of the same letter/number (e.g., 1111, aaa)",
  cantusemorethan3charactersonthekeyboardqweretc:
    "Do not use more than 3 consecutive characters from the keyboard (e.g., qwer)",
  previouslyusedpasswordsaredisabled: "Previously used passwords are disabled",
  avoidusingthesamenumberasyourdateofbirthandphonenumber:
    "Avoid using the same number as your birthdate and phone number",
  makingchanges: "Making changes",
  makingchangesafter30days: "Making changes after 30 days",
  signup: "Sign up",
  enterinformation: "Enter information",
  emailauthentication: "Email authentication",
  acceptterms: "Accept terms",
  hello: "Hello!",
  pleaseacceptthetermstosignupforsite:
    "Please accept the terms to sign up for _sitename_.",
  acceptthetermsintheirentiretyincludingoptinconsent:
    "Accept the terms in their entirety (including opt-in consent)",
  agreeandenteryourinformation: "Agree and enter your information",
  viewall: "View all",
  termination: "termination",
  unadm_mem_detail: "Do you want to terminate this with the administrator?",
  pleaseenteryourid: "Please enter your id",
  pleaseenteryouremail: "Please enter your email",
  check_id_or_passwd: "Please check your ID/password.",
  pleasecheckyourpasswordsafetyrules: "Please check your password safety rules",
  pleaseenteryourpasswordonemoretime:
    "Please enter your password one more time",
  pleaseenteryourcompanyperiodname: "Please enter your company/period name",
  pleaseenteryourlandlineorcellphonenumber:
    "Please enter your landline or cell phone number",
  id_email_already_taken: "This ID/Email is already taken.",
  nm_already_taken: "This name is already taken.",
  email_already_taken: "This email is already taken.",
  email_not_exist: "The email does not exist.",
  mem_not_exist: "The member does not exist.",
  data_not_exist: "The data does not exist.",
  mem_list: "Member List",
  adm_list: "Admin List",
  mem_detailinfo: "Details of Member",
  server_error: "Server Error.",
  nondatesafetyruleo: "Non-date safety rule O",
  informationpower: "Information entry",
  wrong_verification_code: "Not the correct authentication number.",
  wrong_passwd: "Not the correct password.",
  wrong_url: "Not the correct URL.",
  authcode: "Authentification Code",
  verification_code_confirmation: "Verification code has been confirmed.",
  wehavesentaverificationnumbertotheemailyouprovided:
    "We have sent a verification number to the email you provided.",
  entertheverificationnumberintheemailyoureceived:
    "Please enter the verification number from the email you received",
  imailauthentication: "Email authentication",
  yoursignupiscomplete: "Your signup is complete.",
  authenticate: "Authenticate",
  gotohome: "Go to home",
  wevesentaverificationnumbertotheemailyouprovided:
    "We have sent a verification number to the email you provided.",
  pleasealsocheckforsparklesorpromotions:
    "Please also check for sparkles or promotions",
  enteryournewpassword: "Enter your new password!",
  signedup: "complete",
  pleaseconfirmtheverificationnumberbelowtocompleteemailverification:
    "Please confirm the verification number below to complete email verification",
  openapiapproved: "Open API approved",
  openapiauthorizationiscomplete: "Open API authorization is complete.",
  theopenapiauthorizationyourequestedwassuccessfullycompleted:
    "The Open API authorization you requested was successfully completed.",
  youarenowfreetouseallthefeatures: "You are now free to use all the features.",
  yourapikeyis: "Your API key is",
  eojdhjoc: "eoj#dhjoc",
  temporarypasswordinstructions: "Temporary password instructions",
  atemporarypasswordhasbeengenerated:
    "A temporary password has been generated.",
  signinwithyourtemporarypasswordbelow:
    "Sign in with your temporary password below",
  temporarypasswords: "Temporary passwords",
  openapis: "Open APIs",
  my: "My",
  page: "Page",
  complete: "complete",
  wait: "wait",
  ongoing: "ongoing",
  passwordguidepopup: "Password guide popup",
  pleasealsocheckyourspamorpromotionalinboxes:
    "Please also check your spam or promotional inboxes.",
  newgroups: "New groups",
  editthegroupname: "Edit the group name",
  yourenotallowedtologinduetoanoperatingpolicyviolation:
    "You are not allowed to log in due to an operating policy violation.",
  contactyouradministrator: "Contact your administrator",
  saveorder: "Save order",
  saveinthecurrentorder: "Save in the current order",
  allassociateddatawilldisappear: "All associated data will disappear.",
  no_spitial_data: "Spitial data is not exists.",
  issuingapikeys: "Issuing API keys",
  issueapikeystotheselectedcustomers: "Issue API keys to selected customers",
  issueatemporarypassword: "Issue temporary password",
  emailatemporarypassword: "Email temporary password",
  existingbillnumberswillbereset: "Existing bill numbers will be reset.",
  newlayername: "New layer name",
  youllbetakentotheloginpagetologin:
    "You will be taken to the login page to log in.",
  reorder: "Reorder",
  toastphrases: "Toast phrases",
  tasksuccess: "Task success",
  savesuccessful: "Save successful",
  thesaveiscomplete: "The save is complete.",
  updatesuccessful: "Update successful",
  theupdateiscomplete: "The update is complete.",
  successfultransfer: "Successful transfer",
  thetransferiscomplete: "The transfer is complete.",
  successfuldeletion: "Successful deletion",
  thedeletioniscomplete: "The deletion is complete.",
  typicalsuccess: "Typical success",
  itwasprocessedsuccessfully: "It was processed successfully.",
  taskfailed: "Task failed",
  savefailed: "Save failed",
  anerroroccurredwhilesavingpleasetryagaininamoment:
    "An error occurred while saving. Please try again in a moment.",
  updatefailed: "Update failed",
  theupdatefailedpleasetryagaininamoment:
    "The update failed. Please try again in a moment.",
  transferfailure: "Transfer failure",
  anerroroccurredwhileprocessingtherequest:
    "An error occurred while processing the request.",
  deletefailed: "Delete failed",
  thedeletefailedpleasetryagaininamoment:
    "The delete failed. Please try again in a moment.",
  del_con: "Are you sure you want to delete?",
  init_con: "Are you sure you want to reset?",
  save_con: "Are you sure you want to save?",
  mod_con: "Are you sure you want to modify?",
  commonfailures: "Common failures",
  somethingwentwrongpleasecontactyouradministratorerrorcode:
    "Something went wrong. Please contact your administrator. (Error code)",
  apiintegrationconnectionissues: "API integration connection issues",
  anunexpectedproblemhasoccurredpleasecontactyouradministratorerrorcode:
    "An unexpected problem has occurred. Please contact your administrator. (Error code)",
  failedtoloaddata: "Failed to load data",
  failedtoloaddatapleasecontactyouradministratorerrorcode:
    "Failed to load data. Please contact your administrator. (Error code)",
  pagenotfound: "Page not found",
  login: "Login",
  gotologin: "Go to login",
  passwd: "Password",
  lastpasswd: "Last password",
  forgotpasswd: "Forgot password?",
  loginsucc: "Login success.",
  welcome_mem: "Welcome! _mem_",
  loginfail: "Login failed.",
  emailnotvalid: "Please enter a valid email address",
  requiredfield: "This field is required",
  invalidtoken: "Invalid token error",
  invalidtxtcontain: "Contains invalid characters",
  disabled: "Disabled",
  needchangepw: "Password change required",
  uid: "Unique ID",
  authdt: "Authentication Date",
  authsentdt: "Authentication Code Sent Date",
  cannot_mod_del: "Cannot modify or delete.",
  cannot_mod_del: "Cannot modify or delete.",
  logtype: "LogType",
  logstatus: "LogStatus",
  execute: "Execute",
  sendfiletoserver: "Send file to server",
  executorid: "ExecutorId",
  executornm: "ExecutorName",
  targetid: "TargetId",
  createrid: "Creator ID",
  modifierid: "Modifier ID",
  targetnm: "TargetName",
  logcate: "LogCategory",
  pval: "PreviousValue",
  nval: "NewValue",
  logmsg: "LogMessage",
  ip: "IpAddress",
  select_range: "Select Range",
  set_log_lim: "Set log limits",
  set_log_lim_guide: "Please select the period to store the log records",
  wrong_mem_info: "The user information is incorrect.",
  wrong_mem_id: "Invalid username",
  wrong_mem_pass: "Invalid password",
  etc: "ETC",
  etc_config: "ETC Config",
  unlimited: "Unlimited",
  years: "years",
  months: "months",
  sel_mem: "Member select",
  site_nm: "Site name",
  sel_tar_con: "Please select a target.",
  sysconf: "System Config",
  sys: "System",
  conf: "config",
  osm: "OSM",
  tilex: "tile X",
  tiley: "tile Y",
  tilez: "tile Z",
  apikey: "API 키",
  api: "API",
  plzent_lbl_: "Please enter _lbl_",
  del_lbl_conttl: "Confirm _lbl_ deletion",
  refresh: "Refresh",
  extension: "Extension",
  manserv: "Manage Service",
  roadview_price_inquery: "Inquiry about the estimate of road view shooting",
  sms: "SMS",
  kakaotalk: "Kakaotalk",
  slack: "Slack",
  tar_list: "Target list",
  public_access: "Public Access",
  partial_access: "Partial Access",
  no_access: "Private",
  all: "ALL",
  partial: "Partial",
  none: "None",
  access_setting: "Access Setting",
  read: "Read",
  con_pt: "Connect Points",
  discon_pt: "Disconnect Points",
  success: "success",
  fail: "fail",
  ongoing: "ongoing",
  cancel_by_user: "canceled by user",
  cancel_by_system: "canceled by system",
  uploading: "uploading",
  uploaded: "uploaded",
  processing: "processing",
  processed: "processed",
  auto: "Auto",
  noimg: "No Image",
  oid: "Object Detection ID",
  thumbnail: "Object Image",
  cls: "Class",
  ocr: "OCR",
  latitude: "Latitude",
  longitude: "Longitude",
  im_date: "Capture Date",
  im_id: "Street View Image ID",
  proc_date: "Detection Date",
  model_ver: "Model Version",
  extlink: "External Link",
};
